const InvoiceSageCode = `
  id
  analysis
	description
	updatedAt
`;

export default InvoiceSageCode;
